import React, { useState } from 'react';
import './index.css';
import axios from 'axios';

function App() {
    const [showForm, setShowForm] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        secondaryContact: '',
        offer: ''
    });
    const [notification, setNotification] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        //console.log({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            // Send POST request to sale-offer.php
            const response = await axios.post('sale-offer.php', formData);

            //const response = await fetch('sale-offer.php', {
            //  method: 'POST',
            //  body: formData,
            //});
      

            if (response.data.status === 'success') {
                setNotification(response.data.message); // Set success message
                setShowForm(false); // Optionally hide the form
            } else {
                setNotification(response.data.message); // Set error message
            }
        } catch (error) {
            console.error("There was an error submitting the form!", error);
            setNotification("There was an error submitting your offer. Please try again later."); // Set generic error message
        }
    };


    return (
        <div>
            <div className="main-container">
                <div className="section-left">
                    <h1 className="header-main">ReviewStream.com</h1>
                    <ul style={{ listStyleType: 'none' }}>
                        <li className="header-small">20 years online</li>
                        <li className="header-small">164419 unique texts</li>
                        <li className="header-small">10705 authors</li>
                    </ul>
                    <ul className="text-block-ul">
                      <li className="text-block">
                        <span className="for-sale-txt">For sale</span> a well-branded, highly recognizable, and established website since 2005. A true trendsetter and influencer in its niche, this site is expertly promoted, widely trusted, and synonymous with innovation. Don’t miss this rare opportunity to acquire a legacy brand that sets the standard!
                      </li>
                    </ul>
                </div>
                <div className="section-right">
                {notification ? (
                        <div className="notification">
                             {notification}
                        </div>
                    ) : (
                        <>
                            {!showForm ? (
                                <button className="button" onClick={() => setShowForm(true)}>
                                    Submit Your Offer
                                </button>
                            ) : (
                         <div className="form-container active">
                            <h2>Your Offer</h2>
                            <form onSubmit={handleSubmit}>
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Name"
                                    className="input"
                                    required
                                    onChange={handleChange}
                                />
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Email"
                                    className="input"
                                    required
                                    onChange={handleChange}
                                />
                                <input
                                    type="text"
                                    name="secondaryContact"
                                    placeholder="Secondary Contact (optional)"
                                    className="input"
                                    onChange={handleChange}
                                />
                                <textarea
                                    name="offer"
                                    placeholder="Your offer"
                                    className="textarea"
                                    required
                                    onChange={handleChange}
                                />
                                <div className="button-container">
                                  <button type="submit" className="submit-button">Submit</button>
                                </div>
                            </form>
                        </div>
                            )}
                            </>
                        )}
                    </div>
                </div>
            <div className="footer">Own a Legend!</div>
        </div>
    );
}

export default App;
